import React from 'react';
import { Card, Typography, Space } from 'antd';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import LoginButton from '../components/LoginButton';

const { Title, Text, Paragraph } = Typography;

const LoginPage: React.FC = () => {
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #cbd5e1 0%, #91d5ff 50%, #ffc069 100%)',
            overflow: 'hidden',
            position: 'relative'
        }}>
            {/* Decorative Branded Blobs - Higher contrast / saturation */}
            <div style={{
                position: 'absolute',
                width: '750px',
                height: '750px',
                background: 'rgba(24, 144, 255, 0.18)',
                borderRadius: '50%',
                top: '-20%',
                right: '-10%',
                filter: 'blur(130px)',
                zIndex: 0
            }} />
            <div style={{
                position: 'absolute',
                width: '650px',
                height: '650px',
                background: 'rgba(250, 140, 22, 0.12)',
                borderRadius: '50%',
                bottom: '-15%',
                left: '-5%',
                filter: 'blur(110px)',
                zIndex: 0
            }} />

            <Card
                style={{
                    width: 480,
                    borderRadius: '24px',
                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                    background: 'rgba(255, 255, 255, 0.85)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(0, 0, 0, 0.05)',
                    zIndex: 1
                }}
                bodyStyle={{ padding: '48px 40px' }}
            >
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    <div style={{
                        width: '100%',
                        height: 100,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 16
                    }}>
                        <img
                            src="/logo.png"
                            alt="CCTech Logo"
                            style={{ maxHeight: '100%', maxWidth: '240px', objectFit: 'contain' }}
                            onError={(e) => {
                                // Fallback if logo is missing
                                e.currentTarget.style.display = 'none';
                                const parent = e.currentTarget.parentElement;
                                if (parent) {
                                    const fallback = document.createElement('div');
                                    fallback.style.width = '72px';
                                    fallback.style.height = '72px';
                                    fallback.style.backgroundColor = '#1890ff';
                                    fallback.style.borderRadius = '18px';
                                    fallback.style.display = 'flex';
                                    fallback.style.alignItems = 'center';
                                    fallback.style.justifyContent = 'center';
                                    fallback.innerHTML = '<span class="anticon" style="font-size: 40px; color: white;"><svg viewBox="64 64 896 896" focusable="false" data-icon="safety-certificate" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M720 221H304c-13.3 0-24 10.7-24 24v535.4c0 13.3 10.7 24 24 24h416c13.3 0 24-10.7 24-24V245c0-13.3-10.7-24-24-24zm-208 434c-68.5 0-124-55.5-124-124s55.5-124 124-124 124 55.5 124 124-55.5 124-124 124z"></path></svg></span>';
                                    parent.appendChild(fallback);
                                }
                            }}
                        />
                    </div>
                </div>

                <Paragraph style={{ textAlign: 'center', marginBottom: 32, color: '#595959', fontSize: '15px', lineHeight: '1.6' }}>
                    Unlock your potential and master new skills. Sign in to continue your professional growth journey with CCTech.
                </Paragraph>

                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <LoginButton size="large" />
                </Space>

                <div style={{ marginTop: 48, textAlign: 'center' }}>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        © {new Date().getFullYear()} CCTech Enterprise Learning. All rights reserved.
                    </Text>
                </div>
            </Card>
        </div>
    );
};

export default LoginPage;
